
// NATIVE 

// INSTALLED 
import { Dispatch } from 'redux';
import { getDataFormInputsServiceCompany } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setImageRedux } from './filesSlice';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import { getImageServices, getImageServices2 } from '../../services/files.service';


// CUSTOM 


export const getImageStore = (imgName: string, typeImage: string ): any => {

    return async( dispatch: any ) => {

        await dispatch( checkingPreload() );
        
         const result = await getImageServices(imgName, typeImage);

         await dispatch( unCheckingPreload() );
         
         return result;
        
    }
}


export const getImageStore2 = (imgName: string): any => {

    return async( dispatch: any ) => {

        await dispatch( checkingPreload() );
        
         const result = await getImageServices2(imgName);

         await dispatch( unCheckingPreload() );
         
         return result;
        
    }
}






